import React, { useState, useEffect } from "react";
import styled from "styled-components";
import EventCard from "./EventCard";
import { breakpoints } from "../../utils/breakpoints";
import Modal from "../../Sections/Modal/Modal";
import TopBannerVideo from "../../Sections/TopBanner/TopBannerVideo";
import { motion } from "framer-motion";

// banner video
import bannerVid from "../../videos/SecondTestCompressEvents.mp4";

// event thumbnails
import lisbon from "../../images/new2024sum.png";
import egypt from "../../images/egypt-eventspage.png";
import islandCrete from "../../images/island-crete-eventspage.png";
import jamaica from "../../images/jamaica-eventspage.png";
import northAmerican from "../../images/north-american-eventspage.png";
import puntaCana from "../../images/punta-cana-eventspage.png";
import summerSymp from "../../images/summer-symp-eventspage.png";
import womensGala from "../../images/womens-gala-eventspage.png";
import northSouth from "../../images/north-x-south-eventspage.png";
import summit2022 from "../../images/NewSite2022Summit.png";
import RiveraM from "../../images/RiveraMayaBanner.png";
import Ignite from "../../images/ignitePlayButton.png";
import na2023 from "../../images/NorthAmerican2023EventsPage.png";
import summerSymp23 from "../../images/summerSymp23new.png";
import stJames from "../../webp/stjames-eventpage.webp";
import UniteEvent from "../../images/pastUniteEvent.png";
import gala2023 from "../../images/2023galaEvent.png";
import spainLS from "../../webp/spainLSevent.webp";
import impact from "../../images/impactPast2024.png";
import evolveC from "../../images/EVOLVErecapevents-2.png";
import ibiza from "../../images/ibizaPast.png";
import ascend from "../../images/ascendyoutube.png";
import can2025 from "../../images/can2025.png";
import breakout from "../../images/Breakout Next era upcoming-01.png";
import nextera from "../../images/Breakout Next era upcoming-02.png";

const StyledDiv = styled.div`
	overflow-x: hidden;
	background: #0A0B0D 0% 0% no-repeat padding-box;
	color: white;

	.videoEvent {
		width: 100%;
	}

	.content-container {
		padding: 100px 0;

		.heading {
			text-align: left;
			background: linear-gradient(180deg, #89D0C2 0%, #44B2DD 100%);
					font-family: "nexa-bold";
					background-clip: text;
					font-weight: 900;
					-webkit-background-clip: text;
					-webkit-text-fill-color: transparent;
			padding-bottom: 10px;
			font-weight: normal;
		}

		.events-container {
			display: grid;
			grid-template-columns: 1fr 1fr;
			grid-gap: 100px;
			padding: 50px 0;
			margin-bottom: 50px;
		}

		.modal-container {
			display: none;
		}
	}

	@media screen and ${breakpoints.device.mobileL} {
		.content-container {
			padding-top: 25px;
			width: 90%;

			.heading {
				font-size: 8vw;
				padding: 15px 0;
			}

			.events-container {
				grid-template-columns: 1fr;
				grid-gap: 40px;
				margin-bottom: 20px;
			}
		}
	}
`;

const Events = () => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [vidCode, setVidCode] = useState(null);

	useEffect(() => {
		var modal = document.getElementById("modal");
		var video = document.getElementById("vimeo-iframe");

		if (isModalOpen) {
			modal.style.display = "block";
		} else {
			modal.style.display = "none";
			var temp = video.getAttribute("src")
			video.setAttribute("src", temp);
		}
	}, [isModalOpen]);

	return (
		<StyledDiv>
			<TopBannerVideo
				video={bannerVid}
				txt={
					<>
						<b>See the world</b> with us!
						iGenius hosts and attends
						numerous events throughout the
						year all around the world.
					</>
				}
			/>
			<div className="content-container">
				<div className="upcoming-events-section">
					<motion.div
						initial={{ opacity: 0, x: -200, y: -50 }}
						whileInView={{
							opacity: 1,
							x: 0, y: 0
						}}
						viewport={{ once: true }}
						transition={{
							type: "tween",
							duration: 1,
						}}>
						<div className="heading">
							Upcoming Events
						</div>
					</motion.div>
					<div className="events-container">
						{upcomingEvents.map(
							(
								upcomingEvent,
								idx
							) => (
								<EventCard
									key={
										idx
									}
									data={
										upcomingEvent
									}
									buyButton={
										upcomingEvent.buyButton
									}
									learnMoreButton={
										upcomingEvent.learnMoreButton
									}
									isModalOpen={
										isModalOpen
									}
									setIsModalOpen={
										setIsModalOpen
									}
									setVidCode={
										setVidCode
									}
								/>
							)
						)}
					</div>
				</div>
				<div className="past-events-section">
					<motion.div
						initial={{ opacity: 0, x: -200, y: -50 }}
						whileInView={{
							opacity: 1,
							x: 0, y: 0
						}}
						viewport={{ once: true }}
						transition={{
							type: "tween",
							duration: 1,
						}}>
						<div className="heading">
							Past Events
						</div>
					</motion.div>
					<div className="events-container">
						{pastEvents.map(
							(pastEvent, idx) => (
								<EventCard
									key={
										idx
									}
									data={
										pastEvent
									}
									isModalOpen={
										isModalOpen
									}
									setIsModalOpen={
										setIsModalOpen
									}
									setVidCode={
										setVidCode
									}
								/>
							)
						)}
					</div>
				</div>
				<div id="modal" className="modal-container">
					<Modal
						vidType="youtube"
						vidCode={vidCode}
						setIsModalOpen={setIsModalOpen}
					/>
				</div>
			</div>
		</StyledDiv>
	);
};

const upcomingEvents = [

	{
		title: "Cancun Incentive",
		desc: "Qualifiers will get a 3-night stay at the all inclusive AVA Resort Cancun on April 27th - 30th, 2026 in Cancun, Mexico! We can't wait to celebrate our top performers! During the event we'll host a stunning welcome reception, have an exclusive training and mastermind session, hang out on the beautiful beaches, enjoy some team building activities, and attend a luxurious awards dinner! Multiple qualification periods = multiple chances to qualify!",
		image: can2025,
		location: "Cancun, Mexico",
		learnMoreButton: "https://igeniusglobal.io/images/Cancun_English.pdf",
		vidCode: "BspkSZ-TiAo   "
	},
	{
		title: "Breakout",
		desc: "Breakout is coming to Budapest, Hungary—where we'll break barriers, break limits, and break out into a bold new era of iGenius! Join us next summer for an electrifying European convention full of training, inspiration, and connection! More details coming soon!",
		image: breakout,
		location: "Budapest, Hungary",
		buyButton: "https://igeniusevents.com/Breakout",
		
	},
];

const pastEvents = [
		{
		title: "EVOLVE - 2025 European Convention",
		desc: "The EVOLVE European convention was a powerful two-day experience full of high-impact training from iGenius corporate, top field leaders, and elite iGenius educators. Attendees walked away inspired and recharged—armed with game-changing strategies, in-depth product education, leadership development, and a renewed commitment to the iGenius mission.",
		image: evolveC,
		location: "Prague, Czech Republic",
		vidCode: "upjjOABv2i8 "
	},
	{
		title: "Ibiza Spain Incentive",
		desc: "We had an unforgettable time on the island of Ibiza at the luxurious all-inclusive TRS Ibiza Hotel! We had an amazing rooftop welcome ceremony during sunset, hosted a great training session, played volleyball on the beach, and ended the event celebrating our top performers at an energy filled recognition dinner.",
		image: ibiza,
		location: "Ibiza, Spain",
		vidCode: "fYl4oBUTV_Y "
	},
	{
		title: "ASCEND - 2025 U.S. Convention",
		desc: "The ASCEND U.S. convention brought the iGenius community together for an unforgettable weekend full of growth, inspiration, and momentum. New heights were reached, and new journeys began in Las Vegas, Nevada for all those who attended.",
		image: ascend,
		location: "Las Vegas, Nevada",
		vidCode: "gIGfMZxtrMc"
	},
	{
		title: "2024 Leadership Summit",
		desc: "The 2024 Leadership Summit was filled with our top field leaders from around the world. We had great mastermind sessions identifying the needs of our business, fun team building activities, and we all helped shape the future of iGenius.",
		image: lisbon,
		location: "Lisbon, Portugal",
		vidCode: "AyrUrNX0TwY"
	},
	{
		title: "iMPACT - 2024 U.S Event",
		desc: "At iMPACT we came together to learn, celebrate, and grow in a variety of areas. Top field leaders, iGenius corporate, and iGenius market educators helped attendees feel inspired to take control of their financial future, shape their life, and helped everyone leave with a sense of empowerment!",
		image: impact,
		location: "Orlando, Florida",
		vidCode: "QLiWk9Jk7YQ"
	},
	{
		title: "UNITE - 2024 European Convention",
		desc: "At UNITE attendees joined forces with the corporate team, top field leaders, and guest speakers. With record breaking crowds, we came together to unite and take iGenius to the next level!",
		image: UniteEvent,
		location: "Düsseldorf, Germany", 
		vidCode: "1cSk3WBAR1M",
	},
	{
		title: "St. James Incentive",
		desc: "We had a fantastic iGenius incentive trip at the Secrets St. James resort in Montego Bay, Jamaica! We celebrated some of our top producer's success, had exclusive training, went on an amazing waterfall excursion, and had a special celebratory recognition dinner party.",
		image: stJames,
		location: "Montego Bay, Jamaica",
		vidCode: "eroq0Br5Hk8",
	},
	{
		title: "2023 Leadership Summit",
		desc: "The 2023 Leadership Summit was held in Madrid, Spain at the beautiful Melia Princessa Hotel. Attendees enjoyed an awards dinner, team building activities, and got the opportunity to mastermind with leaders from all around the world and the corporate team to help shape the future of iGenius.",
		image: spainLS,
		location: "Madrid, Spain",
		vidCode: "-gPIXCvcqD4",
	},
	{
		title: "iGenius Women's Gala 2023",
		desc: "Top iGenius female leaders hosted the unforgettable Wome's Gala in Mainz, Germany. Hundreds of women gathered together to learn, grow, celebrate, and empower each other.",
		image: gala2023,
		location: "Mainz, Germany",
		vidCode: "0XMK21KG0Ec",
	},
	{
		title: "Summer Symposium 2023",
		desc: "iGenius top field leaders put together an amazing, value packed event. Attendees received top notch training, team building, and experienced an unforgettable yacht party!",
		image: summerSymp23,
		location: "Hollywood, FL",
		vidCode: "kUy7uay9_FI",
	},
	{
		title: "IGNITE 2023",
		desc: "We had an amazing IGNITE European Convention at the RTM Stage in Rotterdam, Netherlands! The event was filled with exclusive training, insights, and inspiration to IGNITE 2023!",
		image: Ignite,
		location: "Rotterdam, Netherlands",
		vidCode: "xj2xiv-8TYM",
	},
	{
		title: "Riviera Maya Incentive",
		desc: "We had an awesome iGenius incentive trip in Riviera Maya, Mexico. We celebrated some of our top producer's success, had special trainings, enjoyed the beautiful amenities and beaches, and went on an unforgettable excursion swimming with turtles.",
		image: RiveraM,
		location: "Riviera Maya, Mexico",
		vidCode: "rlCX59sLukA",
		buyButton: "",
	},
	{
		title: "2023 North American Kickoff",
		desc: "iGenius members from all over North America attended the 2023 North American Kickoff in Atlanta, Georgia. The event was hosted by top iGenius field leaders. Attendees benefited from advanced service, product, and marketing training. The event was closed with an unforgettable awards ceremony celebrating the success and growth of the company and its distributors.",
		image: na2023,
		location: "Atlanta, Georgia",
		vidCode: "xdRtbKq7HQM",
	},
	{
		title: "2022 Leadership Summit",
		desc: "The 2022 Leadership Summit was held in Las Vegas, Nevada. Qualifiers got to benefit from advanced training, mastermind sessions, special awards, and an awesome off-site team building activity at Top Golf!",
		image: summit2022,
		location: "Las Vegas, Nevada",
		vidCode: "eelhjgWfDIE",
	},
	{
		title: "iGenius Women's Gala 2022",
		desc: "Top iGenius female leaders hosted an unforgettable iGenius Women's Gala in Stuttgart, Germany. Hundreds of women gathered together and were empowered by special guest speakers and an open panel event focusing on rising stars, leaders, and the power of iGenius.",
		image: womensGala,
		location: "Stuttgart, Germany",
		vidCode: "W-kEAt0XXEU",
	},
	{
		title: "Punta Cana Incentive",
		desc: "We had an awesome iGenius incentive trip in Punta Cana, Dominican Republic! We celebrated some of our top producer's success, had top notch training, and enjoyed the sun, sand, and relaxed on the beautiful beaches!",
		image: puntaCana,
		location: "Punta Cana, DOM REP",
		vidCode: "E2rc0y4qp0c",
	},
	{
		title: "Summer Symposium 2022",
		desc: "iGenius top field leaders hosted the 2022 Summer Symposium in Hollywood, Florida. There was an event, advanced training, team building, and a yacht party dinner cruise!",
		image: summerSymp,
		location: "Hollywood, FL",
		vidCode: "Hk1odkdD3Xo",
	},
	{
		title: "North American Kickoff",
		desc: "The North American Kickoff event in Atlanta, Georgia was hosted by iGenius top field leaders. Attendees benefited from advanced training on iGenius products, mindset, marketing, and business building.",
		image: northAmerican,
		location: "Atlanta, GA",
		vidCode: "x6WcQ-QSf-k",
	},
	{
		title: "Island of Crete Incentive",
		desc: "iGenius celebrated their top producer's success in Crete, Greece! Attendees got to mix and mingle with the iGenius corporate team, receive top notch training, and enjoy one of the most beautiful islands in the world!",
		image: islandCrete,
		location: "Crete,GR",
		vidCode: "zOcWAOsAZyQ",
	},
	{
		title: "HODL Summit in Egypt",
		desc: "iGenius top field leaders hosted an unforgettable event in Cairo, Egypt!",
		image: egypt,
		location: "Cairo, EG",
		vidCode: "Zhwh15otWKk",
	},
	{
		title: "Jamaica Incentive Trip 2021",
		desc: "iGenius celebrated their top producers in Montego Bay, Jamaica! There was food, drinks, golf, training, recognition, good company, and lots of fun in the sun!",
		image: jamaica,
		location: "Montego Bay, JA",
		vidCode: "oUDcimUCnUQ",
	},
	{
		title: "North X South 3",
		desc: "The North X South 3 event was held in Jensen Beach, Florida. Attendees benefited from a jam packed day of training, education, recognition, and special announcements!",
		image: northSouth,
		location: "Jensen Beach, FL",
		vidCode: "xCxjs0-Mnx8",
	},
];

export default Events;
